import { motion } from "framer-motion";

const SHOTS = [
  { src: "/photos/cookies.jpg", cap: "Fig. 02 — The cookie tray", cls: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/photos/brownies.jpg", cap: "Fig. 03 — Straight from the tin", cls: "md:col-span-8", ratio: "aspect-[16/10] md:aspect-[19/10]" },
  { src: "/photos/focaccia-dough.jpg", cap: "Fig. 04 — Dimpled by hand", cls: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/photos/cheesecake.jpg", cap: "Fig. 05 — The signature", cls: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/photos/focaccia-baked.jpg", cap: "Fig. 06 — Golden & dimpled", cls: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/photos/cheesecake-plate.jpg", cap: "Fig. 07 — One perfect cup", cls: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/photos/cooling-racks.jpg", cap: "Fig. 08 — The day's batch", cls: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/photos/cheesecake-cups.jpg", cap: "Fig. 09 — Oreo & berry cups", cls: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/photos/brownie-walnut.jpg", cap: "Fig. 10 — Walnut, straight up", cls: "md:col-span-6", ratio: "aspect-[4/3]" },
  { src: "/photos/brownie-hazelnut.jpg", cap: "Fig. 11 — Hazelnut edition", cls: "md:col-span-6", ratio: "aspect-[4/3]" },
];

export default function Gallery() {
  return (
    <section id="gallery" className="scroll-mt-24 py-24 sm:py-36">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="mb-14 sm:mb-20"
        >
          <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-rust mb-4">
            The Contact Sheet
          </p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-2xl">
            Shot on the kitchen table,{" "}
            <span className="italic text-rust">not in a studio.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-5 sm:gap-7">
          {SHOTS.map((s, i) => (
            <motion.figure
              key={s.src + i}
              data-testid={`gallery-item-${i + 1}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.1 }}
              className={`group ${s.cls}`}
            >
              <div className="overflow-hidden rounded-[20px] border-[3px] border-ink">
                <img
                  src={s.src}
                  alt={s.cap}
                  loading="lazy"
                  className={`w-full ${s.ratio} object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.06]`}
                />
              </div>
              <figcaption className="mt-3 font-mono text-[10px] uppercase tracking-[0.22em] text-mutedbrown group-hover:text-rust transition-colors duration-300">
                {s.cap}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
